export const PERMISSIONS = {
  VIEW_SUBSCRIPTION_VIDEOS: 'VIEW_SUBSCRIPTION_VIDEOS',
  VIEW_ALL_VIDEOS: 'VIEW_ALL_VIDEOS',
  DOWNLOAD_VIDEO: 'DOWNLOAD_VIDEO',
};
